import { render, staticRenderFns } from "./table2.vue?vue&type=template&id=56983a4c&scoped=true"
import script from "./table2.vue?vue&type=script&lang=js"
export * from "./table2.vue?vue&type=script&lang=js"
import style0 from "./table2.vue?vue&type=style&index=0&id=56983a4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56983a4c",
  null
  
)

export default component.exports